import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { App, LoadingController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { CommonProvider } from '../../providers/common/common';

@Injectable()
export class ApiProvider {
  loader;
  is_loader:boolean = false;

  constructor(
    public app: App,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public storage: Storage,
    public comProv: CommonProvider
  ) {}

  get(url, params=null): Promise<any> {
    let token = localStorage.getItem('token');
    let options = {
      params: new HttpParams({fromObject: params})
    };
    if (token && !this.comProv.isPc()) {
      options['headers'] = {'Authorization': 'Bearer ' + token};
    }

    return this.http.get(url, options).timeout(20000).toPromise();
  }

  post(url, params=null, raw=null): Promise<any> {
    let body;
    if (params) {
      body = new HttpParams({fromObject: params});
    } else if (raw) {
      body = raw;
    }
    let token = localStorage.getItem('token');
    if (token) {
      let options = {
        headers: {'Authorization': 'Bearer ' + token}
      };
      return this.http.post(url, body, options).timeout(20000).toPromise();
    }

    return this.http.post(url, body).timeout(20000).toPromise();
  }

  patch(url, params=null): Promise<any> {
    let body = new HttpParams({fromObject: params});
    let token = localStorage.getItem('token');
    if (token) {
      let options = {
        headers: {'Authorization': 'Bearer ' + token}
      };
      return this.http.patch(url, body, options).timeout(20000).toPromise();
    }

    return this.http.patch(url, body).timeout(20000).toPromise();
  }

  delete(url, params=null): Promise<any> {
    let token = localStorage.getItem('token');
    let options = {
      params: new HttpParams({fromObject: params})
    };
    if (token) {
      options['headers'] = {'Authorization': 'Bearer ' + token};
    }

    return this.http.delete(url, options).timeout(20000).toPromise();
  }

  detaError(data) {
    let message = '[' + data['statusCode'] + ']' + data['message'];
    this.comProv.dispAlert(message);
  }

  statusError(error, navCtrl, is_return=false) {
    console.log('error', error);

    let message = this.getErrorMessage(error, 'エラーが発生しました。');
    
    if (error['status'] == 401) {
      // 認証切れ
      this.getToken(navCtrl);
      //localStorage.removeItem('token');
      //this.comProv.reload();
    } else if (error['status'] == 500 || error['status'] == 503) {
      // サービスが提供できない
      navCtrl.setRoot(
        'ErrorPage',
        {message: message}
      );
    } else {
      if (is_return) {
        return message;
      } else {
        this.comProv.dispAlert(message);
      }
    }
  }

  getErrorMessage(error, defult_text) {
    let message:string;

    if (!error['status']) {
      message = '通信状態が安定しておりません。';
    } else if (error['status'] >= 500 && error['status'] < 600) {
        // 500系エラー
        message = '現在ご利用いただけません。しばらくしてからもう一度お試しください。';
        if (error['error']) {
          if (error['error']['statusCode']) {
            message = '[' + error['error']['statusCode'] + ']' + error['error']['message'];
          }
        }
    } else {
      if (error['error']) {
        if (error['error']['message']) {
          message = error['error']['message'];
        } else {
          if (error['error']['errors']) {
            let errors = error['error']['errors'];
            message = '';
            for (let key in errors) {
              message += errors[key] + '　';
            }
          }
        }
      }
      if (!message) {
        message = '（' + error['status'] + '）' + defult_text;
      }
    }

    return message;
  }

  getToken(navCtrl) {
    if (this.comProv.isPc()) {
      return;
    }
    let service_data = this.comProv.getService();
    
    this.storage.get('uid').then((val) => {
      if (!val || val == '' || val == 'null') {
        if (this.comProv.isApp()) {
          this.comProv.dispAlert('アプリを再起動してください。');
        } else {
          this.comProv.logout();
          this.comProv.restart();
        }
        return;
      }

      let user_env = [];
      user_env['uid'] = val;
      this.comProv.setUserEnv(user_env);

      this.dispLoader();
      this.post(service_data['_links']['user_authenticate']['href'],user_env)
      .then(data => {
        this.removeLoader();
        if (data['statusCode'] != '000') {
          return;
        }
        this.comProv.setUser(data['data']);
        localStorage.setItem('token', data['token']);
        
        this.comProv.reload();
        //navCtrl.setRoot('home');
      }).catch(error => {
        this.removeLoader();
        
        if (error['status'] == 500 || error['status'] == 503) {
          let message = this.getErrorMessage(error, '現在ご利用いただけません。しばらくしてからもう一度お試しください。');
          // サービスが提供できない
          navCtrl.setRoot(
            'ErrorPage',
            {message: message}
          );
        }
      });
    });
  }

  dispLoader() {
    if (this.is_loader) {
      return;
    }
    this.is_loader = true;
    this.loader = this.loadingCtrl.create({
      spinner: "dots",
      showBackdrop: false,
      duration: 20000,
      cssClass: 'loader_common'
    });
    this.loader.present();
  }

  removeLoader() {
    if (!this.is_loader || !this.loader) {
      return;
    }
    this.is_loader = false;
    try {
      this.loader.dismiss();
      this.loader = null;
    } catch(e) {
      console.log(e);
    }
  }

  getExternal(url, params=null): Promise<any> {
    let options = {
      params: new HttpParams({fromObject: params})
    };

    return this.http.get(url, options).timeout(20000).toPromise();
  }

  postExternal(url, params=null): Promise<any> {
    if (params) {
      for (let key in params) {
        params[key] = encodeURIComponent(params[key]);
      }
    }
    console.log('params', params);
    let body = new HttpParams({fromObject: params});

    return this.http.post(url, body).timeout(20000).toPromise();
  }

  statusErrorExternal(error, key_names=null, page='') {
    let message:string = '';

    if (!error['status']) {
      // レスポンスなし
      message = '連携システムの通信状態が安定しておりません。';
    } else if (error['status'] == 401) {
      // 認証切れ
      /*let external_data = this.comProv.getExternalData();
      external_data['access_token'] = null;
      localStorage.setItem('external_data', JSON.stringify(external_data));*/
      message = '連携システムとの認証が必要です。';
    } else if (error['status'] >= 500 && error['status'] < 600) {
      // 500系エラー
      message = '現在連携システムがご利用いただけません。しばらくしてからもう一度お試しください。';
    } else if (error['error']) {
      if (error['error']['message']) {
        message = error['error']['message'];
      } else if (error['error']['errors']) {
        let errors = error['error']['errors'];
        for (let key in errors) {
          if (key_names) {
            if (key_names[key]) {
              message += key_names[key] + '：';
            }
          }
          message += errors[key] + '<br />';
        }
      }
    }

    if (!message) {
      message = '（' + error['status'] + '）' + '連携システムにエラーが発生しました。';
    }
    this.comProv.dispAlert(message);

    let exception = '';
    if (error['error']) {
      if (error['error']['exception']) {
        exception = error['error']['exception'];
      }
    }
    this.comProv.sendLog({'name':page,'result':'ng','status':error['status'],'exception':exception});
  }

  getFeed(url, params=null, is_token=null): Promise<any> {
    let options = {params: new HttpParams({fromObject: params})};
    options['responseType'] = 'text';
    if (is_token) {
      let rss_token = this.comProv.getOptionsValue('rss_token');
      options['headers'] = {'Authorization': 'Bearer ' + rss_token};
    }

    return this.http.get(url, options).timeout(20000).toPromise();
  }
}


// WEBPACK FOOTER //
// ./src/providers/api/api.ts